import { Component, OnInit, OnDestroy } from '@angular/core';
import { BillingValorizationListener } from '../../../services/billing/billing-valorization-listener';
import { WizardStep } from '../../../wizard/wizard.component';
import { BillingOrdenControlWizardService } from '../../../services/billing/billing-orden-control-wizard.service';
import { toTypeScript } from '@angular/compiler';
import { MedicalAppointmentProcedure } from '../../../model/medical-appointment-procedure';
import { Center } from '../../../model/center';
import { FilterService } from '../../../services/filter.service';
import { BillingValorization } from '../../../model/billing/billing-order-control';
import { BillingMedicalAppointmentProcedureEditDialogComponent, BillingMedicalAppointmentProcedureEditResponse } from '../../dialogs/billing-medical-appointment-procedure-edit-dialog/billing-medical-appointment-procedure-edit-dialog.component';
import { MatDialog } from '@angular/material';
import { BillingStateFilter } from '../../../model/billing/billing-state-filter';
import { BillingOrderControlService } from '../../../services/billing/billing-order-control.service';
import { CenterFilter } from 'src/app/model/center-filter';

@Component({
  selector: 'app-billing-orden-control-general',
  templateUrl: './billing-orden-control-general.component.html',
  styleUrls: ['./billing-orden-control-general.component.css']
})
export class BillingOrdenControlGeneralComponent implements OnInit, OnDestroy, BillingValorizationListener, WizardStep {

  isInit: boolean;
  procedures: MedicalAppointmentProcedure[] = [];
  centers: CenterFilter[] = [];
  billingStateFilter: BillingStateFilter[] = [];
  billingValorization: BillingValorization;
  loading: boolean;

  constructor(
    private filterService: FilterService,
    private billingOrderControlService: BillingOrderControlService,
    private dialog: MatDialog,
    private billingOrdenControlWizardService: BillingOrdenControlWizardService) {
     billingOrdenControlWizardService.registerBillingValorizationListener(this);
  }

  get completed(): boolean { return true; }

  activate(): void {

  }

  save(): void {
  }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    this.isInit = true;
    this.loading = true;

    this.filterService.getCentersFilter().then((info) => {
      this.centers = info;
    });

    this.billingOrderControlService.getBillingStateFilter().then((info) => {
      this.billingStateFilter = info;
    });
  }

  get practiceRegions(): MedicalAppointmentProcedure[] {
    return this.billingValorization
            .ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
            .filter(v =>
              v.ValorizationItem.MedicalAppointmentProcedure.PracticeRegionAditionalId === null &&
              v.ValorizationItem.MedicalAppointmentProcedure.SetSupplieId === null &&
              v.ValorizationItem.MedicalAppointmentProcedure.Quantity  > 0)
            .map(v => v.ValorizationItem.MedicalAppointmentProcedure);
  }

  get practiceRegionAditionals(): MedicalAppointmentProcedure[] {
    return this.billingValorization
            .ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
            .filter(v =>
              v.ValorizationItem.MedicalAppointmentProcedure.PracticeRegionAditionalId !== null &&
              v.ValorizationItem.MedicalAppointmentProcedure.SetSupplieId === null &&
              v.ValorizationItem.MedicalAppointmentProcedure.Quantity  > 0)
            .map(v => v.ValorizationItem.MedicalAppointmentProcedure);
  }

  get setSupplies(): MedicalAppointmentProcedure[] {
    return this.billingValorization
            .ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
            .filter(v => v.ValorizationItem.MedicalAppointmentProcedure.SetSupplieId !== null &&
              v.ValorizationItem.MedicalAppointmentProcedure.Quantity  > 0)
            .map(v => v.ValorizationItem.MedicalAppointmentProcedure);
  }

  async valorizationChange() {
    if (this.isInit) {
      this.billingValorization = await this.billingOrdenControlWizardService.getBillingValorization();
      this.loading = false;
    }
  }

  edit(medicalAppointmentProcedure: MedicalAppointmentProcedure) {

    const dialogRef = this.dialog.open(BillingMedicalAppointmentProcedureEditDialogComponent, {
      width: '500px',
      data: {
          invoicingCenter: this.getCenter(medicalAppointmentProcedure.InvoicingCenterId),
          invoicingDate: medicalAppointmentProcedure.InvoicingDate
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const response = <BillingMedicalAppointmentProcedureEditResponse>result;
        medicalAppointmentProcedure.InvoicingDate = response.invoicingDate;
        medicalAppointmentProcedure.InvoicingCenterId = response.invoicingCenter.Id;
      }
    });
  }

  getCenterName(centerId?: number) {
    if (!centerId) {
      return '';
    } else {
      return this.centers.find(c => c.Id === centerId).Name;
    }
  }

  getBillingStateName(billingStateId?: number) {
    if (!billingStateId || !this.billingStateFilter) {
      return '';
    } else {
      return this.billingStateFilter.find(c => c.Id === billingStateId).Name;
    }
  }

  getCenter(centerId?: number) {
    if (!centerId) {
      return null;
    } else {
      return this.centers.find(c => c.Id === centerId);
    }
  }

  ngOnDestroy(): void {
    this.billingOrdenControlWizardService.unRegisterBillingValorizationListener(this);
  }
}
